import { gql } from 'graphql-request';

export default gql`
  fragment Video on MediaObjectType {
    title
    url
  }
`;
